export function inviteUrl(gameId: string): string {
  return `${window.location.origin}/join-game?gameId=${gameId}`;
}

export async function shareGame(gameId: string): Promise<'shared' | 'copied' | 'cancelled'> {
  const url = inviteUrl(gameId);
  const text = `Join my Spin & Solve game!\nCode: ${gameId}\n${url}`;
  if (typeof navigator.share === 'function') {
    try {
      await navigator.share({ title: 'Spin & Solve', text, url });
      return 'shared';
    } catch (error) {
      if (error instanceof DOMException && error.name === 'AbortError') {
        return 'cancelled';
      }
    }
  }
  try {
    await navigator.clipboard.writeText(text);
    return 'copied';
  } catch {
    window.prompt('Copy this invite', text);
    return 'copied';
  }
}
